import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";
import { httpsBaseUrl } from "../https-base-url";

const astroBaseUrl = httpsBaseUrl(
  "Astro API URL must be a full https URL, for example https://example.com/api/v2",
);

const relationId = z
  .string()
  .trim()
  .nullish()
  .transform((value) => value ?? undefined);

export const astroSettings = defineIntegrationSettings({
  fields: {
    baseUrl: astroBaseUrl,
    senderRelationId: relationId,
    orderingPartyRelationId: relationId,
    createReturnsEnabled: z.boolean(),
    processReturnsEnabled: z.boolean(),
  },
  secrets: { apiToken: z.string().trim().min(1, "API token is required") },
  connectOnly: {},
  computed: {},
});
